import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { RoutePaths } from '../routes/AppRoutes';
import { AUTH_REDIRECT_URL } from '../common/models/auth.model';
import useAuth from './useAuth/useAuth';

interface RedirectIfAuthProps {
  children: React.ReactElement;
}

export function useRedirectIfAuth(): React.JSXElementConstructor<RedirectIfAuthProps> {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      const initialDestination = sessionStorage.getItem(AUTH_REDIRECT_URL);

      navigate(initialDestination || RoutePaths.ROOT);
    }
  }, [isAuthenticated, isLoading]);

  return useCallback(({ children }: RedirectIfAuthProps) => {
    return children;
  }, []);
}
